export const enum CloseEventCode {
  NORMAL_CLOSURE = 1000
}
